"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCopyToClipboard = useCopyToClipboard;
var _react = require("react");

// Return success

function useCopyToClipboard() {
  const [copiedText, setCopiedText] = (0, _react.useState)(null);
  const copy = async text => {
    if (!navigator.clipboard) {
      console.warn('Clipboard not supported');
      return false;
    }

    // Try to save to clipboard then save it in the state if worked
    try {
      await navigator.clipboard.writeText(text);
      setCopiedText(text);
      return true;
    } catch (error) {
      console.warn('Copy failed', error);
      setCopiedText(null);
      return false;
    }
  };
  return [copiedText, copy];
}